import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import { FaArrowLeft, FaCheck, FaTimes,  FaEye, FaEyeSlash } from "react-icons/fa";

// Tailwind version of EnterpriseList (UI only; logic unchanged)
export default function EnterpriseList() {
  const itemsPerPage = 20; // (not used by API here; UI keeps same pagination logic you had)
  const [page, setPage] = useState(1); // API is 1-based in your original code
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [enterprises, setEnterprises] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [roleFilter, setRoleFilter] = useState("all");
  const [searchType, setSearchType] = useState("enterprise_name");
  const [exportRows, setExportRows] = useState("");
  const [exportLimit, setExportLimit] = useState("");

  const [countLabel, setCountLabel] = useState("");

  function formatCustomDate(dateStr) {
    if (!dateStr) return "N/A";

    // Handle both slashes and ISO formats
    const parts = dateStr.includes("/") ? dateStr.split("/") : dateStr.split("-");
    let day, month, year;

    if (parts.length === 3) {
      // assuming format is DD/MM/YYYY
      [day, month, year] = parts.map((p) => parseInt(p, 10));
      const formatted = new Date(year, month - 1, day);
      if (!isNaN(formatted)) {
        return formatted.toLocaleDateString("en-IN", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        });
      }
    }

    return "Invalid Date";
  }


  const navigate = useNavigate();

  // const handleSearch = async () => {
  //   if (!searchTerm.trim()) {
  //     fetchEnterprises(1);
  //     return;
  //   }

  //   try {
  //     setLoading(true);
  //     const res = await axios.get(`https://spillas.com:3055/enterprises/search`, {
  //       params: {
  //         retailer_code: isNaN(searchTerm) ? searchTerm : undefined,
  //         retailer_id: !isNaN(searchTerm) ? searchTerm : undefined,
  //       },
  //     });

  //     // ✅ Your original assumption: { enterprise: [ ... ] }
  //     if (res.data && Array.isArray(res.data.enterprise)) {
  //       setEnterprises(res.data.enterprise);
  //       setTotalPages(1); // disable pagination during search
  //     } else {
  //       setEnterprises([]);
  //       setTotalPages(1);
  //     }

  //   } catch (error) {
  //     console.error("Error searching enterprise:", error);
  //     setEnterprises([]);
  //     setTotalPages(1);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

 const fetchEnterprisesFromAPI = async (pageNumber = 1, limit = null) => {
  try {
    setLoading(true);

    let url = `http://spillas.com/api/v1/ama-enterprises?page=${pageNumber}`;

    // ✅ Role Filter
    if (roleFilter === "company") url += "&role=2";
    else if (roleFilter === "retailer") url += "&role=5";

    // ✅ Status Filter
    if (statusFilter === "inuse") {
      url += "&default_enterprise=1";
    } else if (statusFilter === "used") {
      url += "&default_enterprise=0";
    } else if (statusFilter === "provision") {
      url += "&default_enterprise=2";
    } else if (statusFilter === "blocked") {
      url += "&enterprise_status=0";
    }

    // ✅ Search Filter
    if (searchTerm.trim()) {
      if (searchType === "retailer_code") {
        url += `&retailer_code=${encodeURIComponent(searchTerm)}`;
      } else if (searchType === "company_name") {
        url += `&company_name=${encodeURIComponent(searchTerm)}`;
      } else {
        url += `&enterprise_name=${encodeURIComponent(searchTerm)}`;
      }
    }

    const res = await axios.get(url);

    if (res.data && Array.isArray(res.data.data)) {
      let data = res.data.data;

      if (statusFilter === "used") {
        data = data.filter(
          (item) =>
            item.default_enterprise === 0 ||
            item.default_enterprise === null ||
            item.default_enterprise === "0" ||
            item.default_enterprise === "null"
        );
      }

      const sorted = data
        .filter((item) => item.created_at)
        .sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

      // ✅ Limit rows only when exporting
      const limitedData = limit ? sorted.slice(0, limit) : sorted;

      const count = res.data.total;
      setCountLabel(`${count} ${roleFilter === "all" ? "All Roles" : roleFilter === "company" ? "Company" : "Retailer"} - ${
        statusFilter === "all"
          ? "All Status"
          : statusFilter === "inuse"
          ? "In Use"
          : statusFilter === "used"
          ? "Used"
          : statusFilter === "provision"
          ? "Provision"
          : "Blocked"
      }`);

      // ✅ Return limited data if used for export
      if (limit) {
        return limitedData;
      }

      // ✅ Otherwise, set for UI display
      setEnterprises(sorted);
      setTotalPages(res.data.last_page || 1);
    } else {
      if (!limit) {
        setEnterprises([]);
        setTotalPages(1);
      }
    }
  } catch (error) {
    console.error("Error fetching enterprises:", error);
    if (!limit) {
      setEnterprises([]);
      setTotalPages(1);
    }
  } finally {
    setLoading(false);
  }
};


  useEffect(() => {
  fetchEnterprisesFromAPI(page);
}, [page, roleFilter, statusFilter]);

const handleSearch = () => {
  setPage(1);
  fetchEnterprisesFromAPI(1);
};


  const handleViewRetailer = (enterprise) => {
    navigate("/pages-profile", { state: { retailerDetails: enterprise } });
  };

  const handleUpdateDefault = async (enterprise) => {
    Swal.fire({
      title: "Are you sure?",
      text: `Do you want to set Retailer ID ${enterprise.retailer_id} as default?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Update",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const res = await axios.put(
            "https://spillas.com:3055/update-enterprise-default",
            {
              role: enterprise.role,
              retailer_id: enterprise.retailer_id,
              enterprise_id:enterprise.id,
            }
          );

          if (res && res) {
            Swal.fire({
              icon: "success",
              title: "Success",
              text: res.message,
              confirmButtonColor: "#3085d6",
            });
          } else {
            Swal.fire({
              icon: "warning",
              title: "No Response",
              text: "Something went wrong!",
            });
          }
        } catch (error) {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: error.response?.message || "Failed to update enterprise!",
          });
        }
      }
    });
  };

  // Build pagination numbers like your original (1 ... n with window)
  const pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1).filter(
    (num) => num === 1 || num === totalPages || (num >= page - 2 && num <= page + 2)
  );

  function PasswordCell({ password }) {
  const [show, setShow] = useState(false);

  // fallback in case password is undefined
  const passwordStr = password || "-";
  const masked = "••••••";

  // ================== ADD THIS FUNCTION ==================



    return (
      <div className="flex items-center gap-2">
        <span className="font-mono truncate max-w-[12rem]">
          {show ? passwordStr : masked}
        </span>
        <button
          onClick={() => setShow((s) => !s)}
          type="button"
          className="p-1 rounded hover:bg-zinc-100"
          aria-label={show ? "Hide password" : "Show password"}
        >
          {show ? <FaEyeSlash /> : <FaEye />}
        </button>
      </div>
    );
  }

  const downloadCSV = async () => {
  try {
    setLoading(true);

    let rowsToExport = [];

    if (exportLimit && !isNaN(exportLimit) && exportLimit > 0) {
      // ✅ If user entered a number, use limited data
      rowsToExport = enterprises.slice(0, exportLimit);
    } else {
      // ✅ If no number entered, fetch ALL data from API
      const allData = await fetchEnterprisesFromAPI(1, 999999); // passing limit triggers return in API call
      rowsToExport = allData || [];
    }

    if (!rowsToExport || rowsToExport.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "No Data",
        text: "No enterprise data available to export.",
      });
      return;
    }

    // ✅ Convert to CSV
    const headers = Object.keys(rowsToExport[0]);
    const csvContent = [
      headers.join(","),
      ...rowsToExport.map((row) =>
        headers.map((h) => `"${row[h] ?? ""}"`).join(",")
      ),
    ].join("\n");

    // ✅ Trigger file download
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `enterprises_${new Date().toISOString().split("T")[0]}.csv`;
    link.click();
  } catch (error) {
    console.error("Error exporting CSV:", error);
    Swal.fire({
      icon: "error",
      title: "Export Failed",
      text: "An error occurred while exporting data.",
    });
  } finally {
    setLoading(false);
  }
};

  return (
    <div className="min-h-screen bg-white text-zinc-900">
      {/* Header / Breadcrumb */}
      {/* <header className="sticky top-0 z-10 border-b border-zinc-200 bg-white/90 backdrop-blur">
        <div className="mx-auto max-w-7xl px-4 py-4">
          <nav className="text-sm text-zinc-500">
            <span className="hover:text-zinc-700">Tables</span>
            <span className="mx-2">/</span>
            <span className="text-zinc-900 font-medium">Manage Enterprises</span>
          </nav>
          <h1 className="mt-1 text-xl font-semibold tracking-tight">Manage Enterprises</h1>
        </div>
      </header> */}

      <main className="mx-auto px-4 py-6 space-y-4">
        {/* Toolbar */}
        <section className="rounded-2xl border border-zinc-200 bg-white p-3 sm:p-4 shadow-sm">
          <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
            
            {/* Left Section */}
            <div className="text-sm space-y-1">
              <span className="block text-zinc-500">List & manage your enterprises.</span>
              <Badge
                color={
                  statusFilter === "used"
                    ? "zinc"
                    : statusFilter === "inuse"
                    ? "emerald"
                    : statusFilter === "provision"
                    ? "rose"
                    : "blue"
                }
              >
                {countLabel || "List & manage your enterprises."}
              </Badge>
            </div>

            {/* Right Section (Filters + Actions) */}
            <div className="flex flex-col md:flex-row md:flex-wrap md:items-center gap-3 w-full">

              {/* 🔹 Status Dropdown */}
              <select
                value={statusFilter}
                onChange={(e) => setStatusFilter(e.target.value)}
                className="flex-1 md:flex-none min-w-[100px] px-3 py-2 rounded-xl bg-white border border-zinc-200 text-sm text-zinc-900 shadow-sm focus:outline-none"
              >
                <option value="all">All Status</option>
                <option value="inuse">In Use</option>
                <option value="used">Used</option>
                <option value="provision">Provision</option>
                <option value="blocked">Blocked</option>
              </select>

              {/* 🔹 Search Type Dropdown */}
              <select
                value={searchType}
                onChange={(e) => setSearchType(e.target.value)}
                className="flex-1 md:flex-none min-w-[50px] px-3 py-2 rounded-xl bg-white border border-zinc-200 text-sm text-zinc-900 shadow-sm focus:outline-none"
              >
                <option value="enterprise_name">Enterprise Name</option>
              </select>

              {/* 🔹 Search Input */}
              <input
                type="text"
                placeholder={`Search by ${searchType.replace("_", " ")}...`}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="flex-1 md:w-[70px] px-3 py-2 rounded-xl border border-zinc-200 bg-white text-sm shadow-sm focus:outline-none"
              />

              {/* 🔹 Buttons Group (Search, Reset, Create) */}
              <div className="flex flex-wrap items-center gap-2">
                <button
                  onClick={handleSearch}
                  className="flex items-center gap-1 px-3 py-2 rounded-xl bg-[#0A3E91] text-white text-sm font-medium shadow-sm hover:bg-[#0c4cad]"
                  title="Search"
                >
                  <i className="ri-search-line text-base"></i>
                  <span className="hidden sm:inline">Search</span>
                </button>

                <button
                  onClick={() => {
                    setRoleFilter("all");
                    setStatusFilter("all");
                    setSearchTerm("");
                    setSearchType("enterprise_name");
                    setPage(1);
                    fetchEnterprisesFromAPI(1);
                  }}
                  className="flex items-center gap-1 px-3 py-2 rounded-xl bg-gray-200 text-gray-800 text-sm font-medium shadow-sm hover:bg-gray-300"
                  title="Reset"
                >
                  <i className="ri-refresh-line text-base"></i>
                  <span className="hidden sm:inline">Reset</span>
                </button>

                <button
                  type="button"
                  onClick={() => navigate("/dashboard/enterprises/create")}
                  className="flex items-center gap-1 justify-center rounded-xl bg-emerald-600 px-3 py-2 text-sm font-medium text-white shadow-sm hover:bg-emerald-500 focus:outline-none"
                  title="Create"
                >
                  <i className="ri-add-line text-base"></i>
                  <span className="hidden sm:inline">Create</span>
                </button>

                <input
                  type="number"
                  min="1"
                  value={exportLimit}
                  onChange={(e) => setExportLimit(e.target.value)}
                  placeholder="Rows"
                  className="w-[50px] rounded-lg border border-gray-300 px-3 py-2 text-sm focus:ring-2 focus:ring-indigo-500 focus:outline-none"
                />

                <button
                  type="button"
                  onClick={downloadCSV}
                  className="flex items-center gap-1 justify-center rounded-xl bg-indigo-600 px-3 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-500 focus:outline-none"
                  title="Export CSV"
                >
                  <i className="ri-download-2-line text-base"></i>
                  <span className="hidden sm:inline">Export CSV</span>
                </button>
              </div>

              {/* 🔹 Export Section (Rows + Export Button) */}
              {/* <div className="flex flex-wrap items-center gap-2"> */}
                
              {/* </div> */}
            </div>


          </div>
        </section>


        {/* Table */}
        <section className="rounded-2xl border border-zinc-200 bg-white shadow-sm overflow-hidden">
          <div className="w-full overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="sticky top-0 bg-blue-50 text-[12px] text-blue-800 uppercase tracking-wide">
                <tr className="border-y border-blue-100">
                  <Th>ID</Th>
                  <Th>Role</Th>
                  <Th>Org ID</Th>
                  <Th>Org Code</Th>
                  <Th className="hidden md:table-cell">Business Name</Th>
                  <Th>Phone</Th>
                  <Th>Email</Th>
                  <Th>Password</Th>
                  <Th>Enterprise Name</Th>
                  <Th>Status</Th>
                  <Th>Count</Th>
                  <Th className="hidden lg:table-cell">Created At</Th>
                  <Th>Active</Th>
                  <Th>Actions</Th>
                </tr>
              </thead>

              {loading ? (
                <tbody>
                  <tr>
                    <td colSpan={9} className="py-10">
                      <div className="flex justify-center">
                        <div className="h-5 w-5 animate-spin rounded-full border-2 border-blue-600 border-t-transparent" />
                      </div>
                      <p className="mt-3 text-center text-sm text-zinc-500">Please wait...</p>
                    </td>
                  </tr>
                </tbody>
              ) : (
                <tbody className="divide-y divide-zinc-100">
                  {enterprises && enterprises.length > 0 ? (
                    enterprises.map((e, index) => (
                      <tr key={e.id} className="hover:bg-zinc-50">
                        <Td>{(page - 1) * itemsPerPage + index + 1}</Td>

                        <Td>
                          {e.role === 5 ? (
                            <Badge color="blue">Retailer</Badge>
                          ) : e.role === 2 ? (
                            <Badge color="emerald">Company</Badge>
                          ) : (
                            <Badge color="zinc">N/A</Badge>
                          )}
                        </Td>

                        <Td>{e.retailer_id}</Td>
                        <Td className="font-mono text-[12px]">{e.retailer_code || "N/A"}</Td>
                        <Td className="hidden md:table-cell">{e.company_name || "N/A"}</Td>
                        <Td>{e.mobile || "N/A"}</Td>
                        <Td>{e.email || "N/A"}</Td>
                        <Td>
                          <PasswordCell password={e.password || "N/A"} />
                        </Td>

                        <Td className="font-medium">{e.enterprise_name || "-"}</Td>
                        
                        <Td>
                          {e.default_enterprise === 1 ? (
                            <Badge color="zinc">Default</Badge>
                          ) : (
                            <Badge color="zinc">N/A</Badge>
                          )}
                        </Td>

                        <Td className="font-medium">{e.device_count || "0"}</Td>

                        <Td className="hidden lg:table-cell">
                          {e.created_at
                            ? formatCustomDate(e.created_at)
                            : "N/A"}
                        </Td>


                        <Td>
                          {e.enterprise_status === 1 ? (
                            <i
                              className="ri-check-line text-green-600 hover:text-green-700 text-xl"
                              title="Active"
                            />
                          ) : (
                            <i
                              className="ri-close-line text-red-600 hover:text-red-700 text-xl"
                              title="Inactive"
                            />
                          )}
                        </Td>

                        <Td>
                          <div className="flex items-center gap-2">
                            
                            <i
                              className="ri-check-double-line text-blue-600 hover:text-blue-700 cursor-pointer text-lg"
                              onClick={() => handleUpdateDefault(e)}
                              title="Set Default"
                            />
                            {/* <i
                              className="ri-eye-line text-emerald-600 hover:text-emerald-700 cursor-pointer text-lg"
                              onClick={() => handleViewRetailer(e)}
                              title="View"
                            />
                            <i
                              className="ri-delete-bin-line text-rose-600 hover:text-rose-700 cursor-pointer text-lg"
                              onClick={() => console.log("delete logic")}
                              title="Delete"
                            /> */}
                          </div>
                        </Td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={9} className="px-3 py-10 text-center text-sm text-zinc-400">
                        No data found
                      </td>
                    </tr>
                  )}
                </tbody>
              )}
            </table>
          </div>

          {/* Pagination (shown only when not searching, same logic) */}
          {!searchTerm && totalPages > 1 && (
            <div className="flex justify-end px-3 py-3">
              <nav className="flex items-center gap-1">
                <button
                  className="rounded-lg border border-zinc-200 px-2 py-1 text-sm disabled:opacity-50 hover:bg-blue-50"
                  onClick={() => setPage((p) => Math.max(1, p - 1))}
                  disabled={page === 1}
                >
                  Prev
                </button>

                {pageNumbers.map((num) => (
                  <button
                    key={num}
                    className={`rounded-lg border px-2.5 py-1 text-sm ${
                      page === num
                        ? "border-blue-600 bg-blue-600 text-white"
                        : "border-zinc-200 text-blue-700 hover:bg-blue-50"
                    }`}
                    onClick={() => setPage(num)}
                  >
                    {num}
                  </button>
                ))}

                <button
                  className="rounded-lg border border-zinc-200 px-2 py-1 text-sm disabled:opacity-50 hover:bg-blue-50"
                  onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
                  disabled={page === totalPages}
                >
                  Next
                </button>
              </nav>
            </div>
          )}
        </section>
      </main>
    </div>
  );
}

/* ---------------- Tiny Tailwind UI atoms (no logic) ---------------- */
function Th({ children, className = "" }) {
  return (
    <th className={`px-3 sm:px-4 py-2 text-left whitespace-nowrap ${className}`}>
      {children}
    </th>
  );
}  

function Td({ children, className = "" }) {
  return <td className={`px-3 sm:px-4 py-2 align-top ${className}`}>{children}</td>;
}

function Badge({ children, color = "zinc" }) {
  const map = {
    blue: "bg-blue-100 text-blue-800 ring-blue-200",
    emerald: "bg-emerald-100 text-emerald-800 ring-emerald-200",
    zinc: "bg-zinc-100 text-zinc-800 ring-zinc-200",
    rose: "bg-rose-100 text-rose-800 ring-rose-200",
  };
  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ring-1 ring-inset ${map[color]}`}
    >
      {children}
    </span>
  );
}


// import React, { useEffect, useState } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import axios from "axios";
// import Swal from "sweetalert2";
// import { FaArrowLeft, FaCheck, FaTimes,  FaEye, FaEyeSlash } from "react-icons/fa";

// // Tailwind version of EnterpriseList (UI only; logic unchanged)
// export default function EnterpriseList() {
//   const itemsPerPage = 20; // (not used by API here; UI keeps same pagination logic you had)
//   const [page, setPage] = useState(1); // API is 1-based in your original code
//   const [totalPages, setTotalPages] = useState(1);
//   const [loading, setLoading] = useState(false);
//   const [enterprises, setEnterprises] = useState([]);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [statusFilter, setStatusFilter] = useState("all");
//   const [roleFilter, setRoleFilter] = useState("all");
//   const [searchType, setSearchType] = useState("retailer_code");

//   const [countLabel, setCountLabel] = useState("");
//   const [rowsToShow, setRowsToShow] = useState(20);



//   const navigate = useNavigate();

//   // const handleSearch = async () => {
//   //   if (!searchTerm.trim()) {
//   //     fetchEnterprises(1);
//   //     return;
//   //   }

//   //   try {
//   //     setLoading(true);
//   //     const res = await axios.get(`https://spillas.com:3055/enterprises/search`, {
//   //       params: {
//   //         retailer_code: isNaN(searchTerm) ? searchTerm : undefined,
//   //         retailer_id: !isNaN(searchTerm) ? searchTerm : undefined,
//   //       },
//   //     });

//   //     // ✅ Your original assumption: { enterprise: [ ... ] }
//   //     if (res.data && Array.isArray(res.data.enterprise)) {
//   //       setEnterprises(res.data.enterprise);
//   //       setTotalPages(1); // disable pagination during search
//   //     } else {
//   //       setEnterprises([]);
//   //       setTotalPages(1);
//   //     }

//   //   } catch (error) {
//   //     console.error("Error searching enterprise:", error);
//   //     setEnterprises([]);
//   //     setTotalPages(1);
//   //   } finally {
//   //     setLoading(false);
//   //   }
//   // };

//  const fetchEnterprisesFromAPI = async (pageNumber = 1) => {
//   try {
//     setLoading(true);

//     let url = `https://spillas.comapi/v1/ama-enterprises?page=${pageNumber}&per_page=${rowsToShow}`;

//     // ✅ Role Filter
//     if (roleFilter === "company") url += "&role=2";
//     else if (roleFilter === "retailer") url += "&role=5";

//     // ✅ Status Filter
//     if (statusFilter === "inuse") {
//       url += "&default_enterprise=1";
//     } else if (statusFilter === "used") {
//       // send 0 to API (if it supports filtering)
//       url += "&default_enterprise=0";
//     } else if (statusFilter === "provision") {
//       url += "&default_enterprise=2";
//     }


//     // ✅ Search Filter
//     if (searchTerm.trim()) {
//       if (searchType === "retailer_code") {
//         url += `&retailer_code=${encodeURIComponent(searchTerm)}`;
//       } else if (searchType === "company_name") {
//         url += `&company_name=${encodeURIComponent(searchTerm)}`;
//       } else {
//         url += `&enterprise_name=${encodeURIComponent(searchTerm)}`;
//       }
//     }

//     const res = await axios.get(url);

//     if (res.data && Array.isArray(res.data.data)) {
//       let data = res.data.data;

//       if (statusFilter === "used") {
//         data = data.filter(
//           (item) =>
//             item.default_enterprise === 0 ||
//             item.default_enterprise === null ||
//             item.default_enterprise === "0" ||
//             item.default_enterprise === "null"
//         );
//       }


//       const sorted = data
//         .filter((item) => item.created_at)
//         .sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

//       const count = res.data.total;
//       console.log("total", count)

//           // Build a label based on filters
//           let roleText = roleFilter === "all" ? "All Roles" : roleFilter === "company" ? "Company" : "Retailer";
//           let statusText =
//             statusFilter === "all"
//               ? "All Status"
//               : statusFilter === "inuse"
//               ? "In Use"
//               : statusFilter === "used"
//               ? "Used"
//               : "Provision";

//           setCountLabel(`${count} ${roleText} - ${statusText}`);


//       setEnterprises(sorted);
//       setTotalPages(res.data.last_page || 1);
//     } else {
//       setEnterprises([]);
//       setTotalPages(1);
//     }
//   } catch (error) {
//     console.error("Error fetching enterprises:", error);
//     setEnterprises([]);
//     setTotalPages(1);
//   } finally {
//     setLoading(false);
//   }
// };




//   useEffect(() => {
//   fetchEnterprisesFromAPI(page);
// }, [page, roleFilter, statusFilter]);

// const handleSearch = () => {
//   setPage(1);
//   fetchEnterprisesFromAPI(1);
// };


//   const handleViewRetailer = (enterprise) => {
//     navigate("/pages-profile", { state: { retailerDetails: enterprise } });
//   };

//   const handleUpdateDefault = async (enterprise) => {
//     Swal.fire({
//       title: "Are you sure?",
//       text: `Do you want to set Retailer ID ${enterprise.retailer_id} as default?`,
//       icon: "question",
//       showCancelButton: true,
//       confirmButtonText: "Yes, Update",
//       cancelButtonText: "Cancel",
//       confirmButtonColor: "#3085d6",
//       cancelButtonColor: "#d33",
//     }).then(async (result) => {
//       if (result.isConfirmed) {
//         try {
//           const res = await axios.put(
//             "https://spillas.com:3055/update-enterprise-default",
//             {
//               role: enterprise.role,
//               retailer_id: enterprise.retailer_id,
//               enterprise_id:enterprise.id,
//             }
//           );

//           if (res && res) {
//             Swal.fire({
//               icon: "success",
//               title: "Success",
//               text: res.message,
//               confirmButtonColor: "#3085d6",
//             });
//           } else {
//             Swal.fire({
//               icon: "warning",
//               title: "No Response",
//               text: "Something went wrong!",
//             });
//           }
//         } catch (error) {
//           Swal.fire({
//             icon: "error",
//             title: "Error",
//             text: error.response?.message || "Failed to update enterprise!",
//           });
//         }
//       }
//     });
//   };

//   // Build pagination numbers like your original (1 ... n with window)
//   const pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1).filter(
//     (num) => num === 1 || num === totalPages || (num >= page - 2 && num <= page + 2)
//   );

//   function PasswordCell({ password }) {
//   const [show, setShow] = useState(false);

//   // fallback in case password is undefined
//   const passwordStr = password || "-";
//   const masked = "••••••";

//   // ================== ADD THIS FUNCTION ==================



//     return (
//       <div className="flex items-center gap-2">
//         <span className="font-mono truncate max-w-[12rem]">
//           {show ? passwordStr : masked}
//         </span>
//         <button
//           onClick={() => setShow((s) => !s)}
//           type="button"
//           className="p-1 rounded hover:bg-zinc-100"
//           aria-label={show ? "Hide password" : "Show password"}
//         >
//           {show ? <FaEyeSlash /> : <FaEye />}
//         </button>
//       </div>
//     );
//   }

//   const downloadCSV = () => {
//   if (!enterprises || enterprises.length === 0) return;

//   // CSV header
//   const headers = [
//     "ID",
//     "Role",
//     "Org ID",
//     "Org Code",
//     "Business Name",
//     "Phone",
//     "Email",
//     "Password",
//     "Enterprise Name",
//     "Status",
//     "Created At",
//   ];

//   // Convert data rows
//   const rows = enterprises.slice(0, rowsToShow).map((e, index) => [
//     index + 1,
//     e.role === 5 ? "Retailer" : e.role === 2 ? "Company" : "N/A",
//     e.retailer_id || "",
//     e.retailer_code || "",
//     e.company_name || "",
//     e.mobile || "",
//     e.email || "",
//     e.password || "",
//     e.enterprise_name || "",
//     e.default_enterprise === "1" ? "Default" : "N/A",
//     e.created_at ? new Date(e.created_at).toLocaleDateString() : "",
//   ]);

//   // Combine header + rows
//   const csvContent =
//     [headers, ...rows]
//       .map((row) =>
//         row
//           .map((cell) => `"${cell?.toString().replace(/"/g, '""')}"`)
//           .join(",")
//       )
//       .join("\n");

//   // Create a blob and download
//   const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
//   const url = URL.createObjectURL(blob);
//   const link = document.createElement("a");
//   link.href = url;
//   link.setAttribute("download", "enterprises.csv");
//   document.body.appendChild(link);
//   link.click();
//   document.body.removeChild(link);
// };



//   return (
//     <div className="min-h-screen bg-white text-zinc-900">
//       {/* Header / Breadcrumb */}
//       {/* <header className="sticky top-0 z-10 border-b border-zinc-200 bg-white/90 backdrop-blur">
//         <div className="mx-auto max-w-7xl px-4 py-4">
//           <nav className="text-sm text-zinc-500">
//             <span className="hover:text-zinc-700">Tables</span>
//             <span className="mx-2">/</span>
//             <span className="text-zinc-900 font-medium">Manage Enterprises</span>
//           </nav>
//           <h1 className="mt-1 text-xl font-semibold tracking-tight">Manage Enterprises</h1>
//         </div>
//       </header> */}

//       <main className="mx-auto max-w-7xl px-4 py-6 space-y-4">
//         {/* Toolbar */}
//         <section className="rounded-2xl border border-zinc-200 bg-white p-3 sm:p-4">
//           <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
//             <div className="text-sm">
             
//               <span className="text-zinc-500">List & manage your enterprises.</span>
//               <div className="text-sm">
//                 <Badge
//                   color={
//                     statusFilter === "used"
//                       ? "zinc"
//                       : statusFilter === "inuse"
//                       ? "emerald"
//                       : statusFilter === "provision"
//                       ? "rose"
//                       : "blue"
//                   }
//                 >
//                   {countLabel || "List & manage your enterprises."}
//                 </Badge>
//               </div>
//             </div>
            
//             <div className="flex flex-col sm:flex-row items-stretch gap-2">
//               {/* Role Dropdown */}
//               <select
//                 value={roleFilter}
//                 onChange={(e) => setRoleFilter(e.target.value)}
//                 className="w-full sm:w-auto px-3 py-2 rounded-xl bg-white border border-zinc-200 text-sm text-zinc-900 focus:outline-none shadow-sm"
//               >
//                 <option value="all">All Roles</option>
//                 <option value="company">Company</option>
//                 <option value="retailer">Retailer</option>
//               </select>

//               {/* Status Dropdown */}
//               <select
//                 value={statusFilter}
//                 onChange={(e) => setStatusFilter(e.target.value)}
//                 className="w-full sm:w-auto px-3 py-2 rounded-xl bg-white border border-zinc-200 text-sm text-zinc-900 focus:outline-none shadow-sm"
//               >
//                 <option value="all">All Status</option>
//                 <option value="inuse">In Use</option>
//                 <option value="used">Used</option>
//                 <option value="provision">Provision</option>
//               </select>

//               {/* 🔍 Search Type Dropdown */}
//               <select
//                 value={searchType}
//                 onChange={(e) => setSearchType(e.target.value)}
//                 className="w-full sm:w-auto px-3 py-2 rounded-xl bg-white border border-zinc-200 text-sm text-zinc-900 focus:outline-none shadow-sm"
//               >
//                 <option value="enterprise_name">Enterprise Name</option>
//                 <option value="retailer_code">Vendor Code</option>
//                 <option value="company_name">Shop Name</option>
//               </select>

//               {/* Search Input */}
//               <input
//                 type="text"
//                 placeholder={`Search by ${searchType.replace("_", " ")}...`}
//                 value={searchTerm}
//                 onChange={(e) => setSearchTerm(e.target.value)}
//                 className="w-full sm:w-50 px-3 py-2 rounded-xl border border-zinc-200 bg-white text-sm shadow-sm"
//               />

//               {/* Search Button */}
//               <button
//                 onClick={handleSearch}
//                 className="px-4 py-2 rounded-xl bg-[#0A3E91] text-white text-sm font-medium shadow-sm hover:bg-[#0c4cad]"
//               >
//                 Search
//               </button>

//               {/* Reset Button */}
//               <button
//                 onClick={() => {
//                   setRoleFilter("all");
//                   setStatusFilter("all");
//                   setSearchTerm("");
//                   setSearchType("enterprise_name");
//                   setPage(1);
//                   fetchEnterprisesFromAPI(1);
//                 }}
//                 className="px-4 py-2 rounded-xl bg-gray-200 text-gray-800 text-sm font-medium shadow-sm hover:bg-gray-300"
//               >
//                 Reset
//               </button>

//               <Link
//                 to="/enterprise/create"
//                 className="inline-flex items-center justify-center rounded-xl bg-emerald-600 px-3 py-2 text-sm font-medium text-white shadow-sm hover:bg-emerald-500 focus:outline-none focus:ring-2 focus:ring-emerald-200"
//               >
//                 Create
//               </Link>

//               <input
//                   type="number"
//                   min=""
//                   placeholder="Rows"
//                   value={rowsToShow}
//                   onChange={(e) => setRowsToShow(Number(e.target.value))}
//                   className="w-13 px-2 py-2 rounded-xl border border-zinc-200 bg-white text-sm shadow-sm"
//                 />

//               <button
//                 type="button"
//                 className="inline-flex items-center justify-center rounded-xl bg-indigo-600 px-3 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-200"
//                 onClick={downloadCSV}
//               >
//                 Export CSV
//               </button>
//             </div>

//           </div>
//         </section>

//         {/* Table */}
//         <section className="rounded-2xl border border-zinc-200 bg-white shadow-sm overflow-hidden">
//           <div className="w-full overflow-x-auto">
//             <table className="w-full text-sm">
//               <thead className="sticky top-0 bg-blue-50 text-[12px] text-blue-800 uppercase tracking-wide">
//                 <tr className="border-y border-blue-100">
//                   <Th>ID</Th>
//                   <Th>Role</Th>
//                   <Th>Org ID</Th>
//                   <Th>Org Code</Th>
//                   <Th className="hidden md:table-cell">Business Name</Th>
//                   <Th>Phone</Th>
//                   <Th>Email</Th>
//                   <Th>Password</Th>
//                   <Th>Enterprise Name</Th>
//                   <Th>Status</Th>
//                   <Th>Count</Th>
//                   <Th className="hidden lg:table-cell">Created At</Th>
//                   <Th>Actions</Th>
//                 </tr>
//               </thead>

//               {loading ? (
//                 <tbody>
//                   <tr>
//                     <td colSpan={9} className="py-10">
//                       <div className="flex justify-center">
//                         <div className="h-5 w-5 animate-spin rounded-full border-2 border-blue-600 border-t-transparent" />
//                       </div>
//                       <p className="mt-3 text-center text-sm text-zinc-500">Please wait...</p>
//                     </td>
//                   </tr>
//                 </tbody>
//               ) : (
//                 <tbody className="divide-y divide-zinc-100">
//                   {enterprises && enterprises.length > 0 ? (
//                     enterprises.slice(0, rowsToShow).map((e, index) => (
//                       <tr key={e.id} className="hover:bg-zinc-50">
//                         <Td>{(page - 1) * itemsPerPage + index + 1}</Td>

//                         <Td>
//                           {e.role === 5 ? (
//                             <Badge color="blue">Retailer</Badge>
//                           ) : e.role === 2 ? (
//                             <Badge color="emerald">Company</Badge>
//                           ) : (
//                             <Badge color="zinc">N/A</Badge>
//                           )}
//                         </Td>

//                         <Td>{e.retailer_id}</Td>
//                         <Td className="font-mono text-[12px]">{e.retailer_code || "N/A"}</Td>
//                         <Td className="hidden md:table-cell">{e.company_name || "N/A"}</Td>
//                         <Td>{e.mobile || "N/A"}</Td>
//                         <Td>{e.email || "N/A"}</Td>
//                         <Td>
//                           <PasswordCell password={e.password || "N/A"} />
//                         </Td>

//                         <Td className="font-medium">{e.enterprise_name || "-"}</Td>
                        
//                         <Td>
//                           {e.default_enterprise === "1" ? (
//                             <Badge color="zinc">Default</Badge>
//                           ) : (
//                             <Badge color="zinc">N/A</Badge>
//                           )}
//                         </Td>

//                         <Td className="font-medium">{e.device_count || "0"}</Td>

//                         <Td className="hidden lg:table-cell">
//                           {e.created_at
//                             ? new Date(e.created_at).toLocaleDateString()
//                             : "N/A"}
//                         </Td>

//                         <Td>
//                           <div className="flex items-center gap-2">
//                             <i
//                               className="ri-check-double-line text-blue-600 hover:text-blue-700 cursor-pointer text-lg"
//                               onClick={() => handleUpdateDefault(e)}
//                               title="Set Default"
//                             />
//                             <i
//                               className="ri-eye-line text-emerald-600 hover:text-emerald-700 cursor-pointer text-lg"
//                               onClick={() => handleViewRetailer(e)}
//                               title="View"
//                             />
//                             <i
//                               className="ri-delete-bin-line text-rose-600 hover:text-rose-700 cursor-pointer text-lg"
//                               onClick={() => console.log("delete logic")}
//                               title="Delete"
//                             />
//                           </div>
//                         </Td>
//                       </tr>
//                     ))
//                   ) : (
//                     <tr>
//                       <td colSpan={9} className="px-3 py-10 text-center text-sm text-zinc-400">
//                         No data found
//                       </td>
//                     </tr>
//                   )}
//                 </tbody>
//               )}
//             </table>
//           </div>

//           {/* Pagination (shown only when not searching, same logic) */}
//           {!searchTerm && totalPages > 1 && (
//             <div className="flex justify-end px-3 py-3">
//               <nav className="flex items-center gap-1">
//                 <button
//                   className="rounded-lg border border-zinc-200 px-2 py-1 text-sm disabled:opacity-50 hover:bg-blue-50"
//                   onClick={() => setPage((p) => Math.max(1, p - 1))}
//                   disabled={page === 1}
//                 >
//                   Prev
//                 </button>

//                 {pageNumbers.map((num) => (
//                   <button
//                     key={num}
//                     className={`rounded-lg border px-2.5 py-1 text-sm ${
//                       page === num
//                         ? "border-blue-600 bg-blue-600 text-white"
//                         : "border-zinc-200 text-blue-700 hover:bg-blue-50"
//                     }`}
//                     onClick={() => setPage(num)}
//                   >
//                     {num}
//                   </button>
//                 ))}

//                 <button
//                   className="rounded-lg border border-zinc-200 px-2 py-1 text-sm disabled:opacity-50 hover:bg-blue-50"
//                   onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
//                   disabled={page === totalPages}
//                 >
//                   Next
//                 </button>
//               </nav>
//             </div>
//           )}
//         </section>
//       </main>
//     </div>
//   );
// }

// /* ---------------- Tiny Tailwind UI atoms (no logic) ---------------- */
// function Th({ children, className = "" }) {
//   return (
//     <th className={`px-3 sm:px-4 py-2 text-left whitespace-nowrap ${className}`}>
//       {children}
//     </th>
//   );
// }  

// function Td({ children, className = "" }) {
//   return <td className={`px-3 sm:px-4 py-2 align-top ${className}`}>{children}</td>;
// }

// function Badge({ children, color = "zinc" }) {
//   const map = {
//     blue: "bg-blue-100 text-blue-800 ring-blue-200",
//     emerald: "bg-emerald-100 text-emerald-800 ring-emerald-200",
//     zinc: "bg-zinc-100 text-zinc-800 ring-zinc-200",
//     rose: "bg-rose-100 text-rose-800 ring-rose-200",
//   };
//   return (
//     <span
//       className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ring-1 ring-inset ${map[color]}`}
//     >
//       {children}
//     </span>
//   );
// }




// import React, { useEffect, useState } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import axios from "axios";
// import Swal from "sweetalert2";
// import { FaArrowLeft, FaCheck, FaTimes } from "react-icons/fa";

// // Tailwind version of EnterpriseList (UI only; logic unchanged)
// export default function EnterpriseList() {
//   const itemsPerPage = 15; // (not used by API here; UI keeps same pagination logic you had)
//   const [page, setPage] = useState(1); // API is 1-based in your original code
//   const [totalPages, setTotalPages] = useState(1);
//   const [loading, setLoading] = useState(false);
//   const [enterprises, setEnterprises] = useState([]);
//   const [searchTerm, setSearchTerm] = useState("");

//   const navigate = useNavigate();

//   // Fetch Enterprises with Pagination (UI uses the same logic)
//   const fetchEnterprises = async (pageNumber) => {
//     try {
//       setLoading(true);
//       const res = await axios.get(
//         `https://spillas.com:3055/enterprises?page=${pageNumber}&per_page=20`
//       );

//       // ⚠️ Keeping your original response handling (do not change logic)
//       // List fetch
//       if (res.data && Array.isArray(res.data.enterprises)) {
//         setEnterprises(res.data.enterprises);
//         setTotalPages(res.data.total_pages || 1);
//       } else {
//         setEnterprises([]);
//         setTotalPages(1);
//       }

//     } catch (error) {
//       console.error("Error fetching enterprises:", error);
//       setEnterprises([]);
//       setTotalPages(1);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Search Enterprises by retailer_code OR retailer_id (logic unchanged)
//   const handleSearch = async () => {
//     if (!searchTerm.trim()) {
//       fetchEnterprises(1);
//       return;
//     }

//     try {
//       setLoading(true);
//       const res = await axios.get(`https://spillas.com:3055/enterprises/search`, {
//         params: {
//           retailer_code: isNaN(searchTerm) ? searchTerm : undefined,
//           retailer_id: !isNaN(searchTerm) ? searchTerm : undefined,
//         },
//       });

//       // ✅ Your original assumption: { enterprise: [ ... ] }
//       if (res.data && Array.isArray(res.data.enterprise)) {
//         setEnterprises(res.data.enterprise);
//         setTotalPages(1); // disable pagination during search
//       } else {
//         setEnterprises([]);
//         setTotalPages(1);
//       }

//     } catch (error) {
//       console.error("Error searching enterprise:", error);
//       setEnterprises([]);
//       setTotalPages(1);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (!searchTerm) {
//       fetchEnterprises(page);
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [page]);

//   const handleViewRetailer = (enterprise) => {
//     navigate("/pages-profile", { state: { retailerDetails: enterprise } });
//   };

//   // Confirm & update default enterprise (logic unchanged)
//   const handleUpdateDefault = async (enterprise) => {
//     Swal.fire({
//       title: "Are you sure?",
//       text: `Do you want to set Retailer ID ${enterprise.retailer_id} as default?`,
//       icon: "question",
//       showCancelButton: true,
//       confirmButtonText: "Yes, Update",
//       cancelButtonText: "Cancel",
//       confirmButtonColor: "#3085d6",
//       cancelButtonColor: "#d33",
//     }).then(async (result) => {
//       if (result.isConfirmed) {
//         try {
//           const res = await axios.put(
//             "https://spillas.com:3055/update-enterprise-default",
//             {
//               role: enterprise.role,
//               retailer_id: enterprise.retailer_id,
//               enterprise_id:enterprise.id,
//             }
//           );

//           if (res && res) {
//             Swal.fire({
//               icon: "success",
//               title: "Success",
//               text: res.message,
//               confirmButtonColor: "#3085d6",
//             });
//           } else {
//             Swal.fire({
//               icon: "warning",
//               title: "No Response",
//               text: "Something went wrong!",
//             });
//           }
//         } catch (error) {
//           Swal.fire({
//             icon: "error",
//             title: "Error",
//             text: error.response?.message || "Failed to update enterprise!",
//           });
//         }
//       }
//     });
//   };

//   // Build pagination numbers like your original (1 ... n with window)
//   const pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1).filter(
//     (num) => num === 1 || num === totalPages || (num >= page - 2 && num <= page + 2)
//   );

//   return (
//     <div className="min-h-screen bg-white text-zinc-900">
//       {/* Header / Breadcrumb */}
//       <header className="sticky top-0 z-10 border-b border-zinc-200 bg-white/90 backdrop-blur">
//         <div className="mx-auto max-w-7xl px-4 py-4">
//           <nav className="text-sm text-zinc-500">
//             <span className="hover:text-zinc-700">Tables</span>
//             <span className="mx-2">/</span>
//             <span className="text-zinc-900 font-medium">Manage Enterprises</span>
//           </nav>
//           <h1 className="mt-1 text-xl font-semibold tracking-tight">Manage Enterprises</h1>
//         </div>
//       </header>

//       <main className="mx-auto max-w-7xl px-4 py-6 space-y-4">
//         {/* Toolbar */}
//         <section className="rounded-2xl border border-zinc-200 bg-white p-3 sm:p-4">
//           <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
//             <div className="text-sm">
//               <div className="pt-3 pb-3">
//                 <button
//                   className="bg-blue-500 hover:bg-blue-400 cursor-pointer text-white px-2 py-1 rounded-md flex items-center gap-1"
//                   onClick={() => navigate(-1)}
//                 >
//                   <FaArrowLeft /> Go Back
//                 </button>
//               </div>
//               <span className="text-zinc-500">List & manage your enterprises.</span>
//             </div>
//             <div className="flex flex-col sm:flex-row items-stretch gap-2">
//               <div className="relative w-full sm:w-[280px]">
//                 <input
//                   type="text"
//                   className="w-full rounded-xl border border-zinc-200 bg-white px-3 py-2 pr-20 text-sm outline-none placeholder:text-zinc-400 focus:border-blue-300 focus:ring-2 focus:ring-blue-200"
//                   placeholder="Search by Retailer Code / ID..."
//                   value={searchTerm}
//                   onChange={(e) => setSearchTerm(e.target.value)}
//                   onKeyDown={(e) => e.key === "Enter" && handleSearch()}
//                 />
//                 <div className="absolute right-2 top-1/2 -translate-y-1/2 flex gap-1">
//                   {searchTerm && (
//                     <button
//                       type="button"
//                       className="rounded-lg border border-zinc-200 px-2 text-xs text-zinc-600 hover:bg-zinc-50"
//                       onClick={() => {
//                         setSearchTerm("");
//                         fetchEnterprises(1);
//                       }}
//                     >
//                       Clear
//                     </button>
//                   )}
//                 </div>
//               </div>

//               <button
//                 type="button"
//                 className="inline-flex items-center justify-center rounded-xl bg-blue-600 px-3 py-2 text-sm font-medium text-white shadow-sm hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-200"
//                 onClick={handleSearch}
//                 disabled={loading}
//               >
//                 {loading ? "Searching..." : "Search"}
//               </button>

//               <Link
//                 to="/enterprise/create"
//                 className="inline-flex items-center justify-center rounded-xl bg-emerald-600 px-3 py-2 text-sm font-medium text-white shadow-sm hover:bg-emerald-500 focus:outline-none focus:ring-2 focus:ring-emerald-200"
//               >
//                 Create
//               </Link>
//             </div>
//           </div>
//         </section>

//         {/* Table */}
//         <section className="rounded-2xl border border-zinc-200 bg-white shadow-sm overflow-hidden">
//           <div className="w-full overflow-x-auto">
//             <table className="w-full text-sm">
//               <thead className="sticky top-0 bg-blue-50 text-[12px] text-blue-800 uppercase tracking-wide">
//                 <tr className="border-y border-blue-100">
//                   <Th>ID</Th>
//                   <Th>Role</Th>
//                   <Th>Organization ID</Th>
//                   <Th>Organization Code</Th>
//                   <Th className="hidden md:table-cell">Business Name</Th>
//                   <Th>Enterprise Name</Th>
//                   <Th>Status</Th>
//                   <Th className="hidden lg:table-cell">Created At</Th>
//                   <Th>Actions</Th>
//                 </tr>
//               </thead>

//               {loading ? (
//                 <tbody>
//                   <tr>
//                     <td colSpan={9} className="py-10">
//                       <div className="flex justify-center">
//                         <div className="h-5 w-5 animate-spin rounded-full border-2 border-blue-600 border-t-transparent" />
//                       </div>
//                       <p className="mt-3 text-center text-sm text-zinc-500">Please wait...</p>
//                     </td>
//                   </tr>
//                 </tbody>
//               ) : (
//                 <tbody className="divide-y divide-zinc-100">
//                   {enterprises && enterprises.length > 0 ? (
//                     enterprises.map((e) => (
//                       <tr key={e.id} className="hover:bg-zinc-50">
//                         <Td>{e.id}</Td>

//                         <Td>
//                           {e.role === 5 ? (
//                             <Badge color="blue">Retailer</Badge>
//                           ) : e.role === 2 ? (
//                             <Badge color="emerald">Company</Badge>
//                           ) : (
//                             <Badge color="zinc">N/A</Badge>
//                           )}
//                         </Td>

//                         <Td>{e.retailer_id}</Td>
//                         <Td className="font-mono text-[12px]">{e.retailer_code || "N/A"}</Td>
//                         <Td className="hidden md:table-cell">{e.business_name || "N/A"}</Td>
//                         <Td className="font-medium">{e.enterprise_name}</Td>

//                         <Td>
//                           {e.default_enterprise === "1" ? (
//                             <Badge color="zinc">Default</Badge>
//                           ) : (
//                             <Badge color="zinc">N/A</Badge>
//                           )}
//                         </Td>

//                         <Td className="hidden lg:table-cell">
//                           {e.created_at
//                             ? new Date(e.created_at).toLocaleDateString()
//                             : "N/A"}
//                         </Td>

//                         <Td>
//                           <div className="flex items-center gap-2">
//                             <i
//                               className="ri-check-double-line text-blue-600 hover:text-blue-700 cursor-pointer text-lg"
//                               onClick={() => handleUpdateDefault(e)}
//                               title="Set Default"
//                             />
//                             <i
//                               className="ri-eye-line text-emerald-600 hover:text-emerald-700 cursor-pointer text-lg"
//                               onClick={() => handleViewRetailer(e)}
//                               title="View"
//                             />
//                             <i
//                               className="ri-delete-bin-line text-rose-600 hover:text-rose-700 cursor-pointer text-lg"
//                               onClick={() => console.log("delete logic")}
//                               title="Delete"
//                             />
//                           </div>
//                         </Td>
//                       </tr>
//                     ))
//                   ) : (
//                     <tr>
//                       <td colSpan={9} className="px-3 py-10 text-center text-sm text-zinc-400">
//                         No data found
//                       </td>
//                     </tr>
//                   )}
//                 </tbody>
//               )}
//             </table>
//           </div>

//           {/* Pagination (shown only when not searching, same logic) */}
//           {!searchTerm && totalPages > 1 && (
//             <div className="flex justify-end px-3 py-3">
//               <nav className="flex items-center gap-1">
//                 <button
//                   className="rounded-lg border border-zinc-200 px-2 py-1 text-sm disabled:opacity-50 hover:bg-blue-50"
//                   onClick={() => setPage((p) => Math.max(1, p - 1))}
//                   disabled={page === 1}
//                 >
//                   Prev
//                 </button>

//                 {pageNumbers.map((num) => (
//                   <button
//                     key={num}
//                     className={`rounded-lg border px-2.5 py-1 text-sm ${
//                       page === num
//                         ? "border-blue-600 bg-blue-600 text-white"
//                         : "border-zinc-200 text-blue-700 hover:bg-blue-50"
//                     }`}
//                     onClick={() => setPage(num)}
//                   >
//                     {num}
//                   </button>
//                 ))}

//                 <button
//                   className="rounded-lg border border-zinc-200 px-2 py-1 text-sm disabled:opacity-50 hover:bg-blue-50"
//                   onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
//                   disabled={page === totalPages}
//                 >
//                   Next
//                 </button>
//               </nav>
//             </div>
//           )}
//         </section>
//       </main>
//     </div>
//   );
// }

// /* ---------------- Tiny Tailwind UI atoms (no logic) ---------------- */
// function Th({ children, className = "" }) {
//   return (
//     <th className={`px-3 sm:px-4 py-2 text-left whitespace-nowrap ${className}`}>
//       {children}
//     </th>
//   );
// }  

// function Td({ children, className = "" }) {
//   return <td className={`px-3 sm:px-4 py-2 align-top ${className}`}>{children}</td>;
// }

// function Badge({ children, color = "zinc" }) {
//   const map = {
//     blue: "bg-blue-100 text-blue-800 ring-blue-200",
//     emerald: "bg-emerald-100 text-emerald-800 ring-emerald-200",
//     zinc: "bg-zinc-100 text-zinc-800 ring-zinc-200",
//     rose: "bg-rose-100 text-rose-800 ring-rose-200",
//   };
//   return (
//     <span
//       className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ring-1 ring-inset ${map[color]}`}
//     >
//       {children}
//     </span>
//   );
// }
